import { edgeConfig } from '@mntn-dev/edge-config'
import { env } from '@mntn-dev/env'
import { runningOnServer } from '@mntn-dev/utilities'

export const coreAuthConfig = () => {
  const domain = new URL(
    runningOnServer() ? env.BASE_URL : window.location.origin
  ).hostname

  return {
    clerk: {
      clerkFrontendUrl: `https://clerk.${domain}`,
      publishableKey: env.NEXT_PUBLIC_CLERK_PUBLISHABLE_KEY,
      signInUrl: env.NEXT_PUBLIC_CLERK_SIGN_IN_URL,
      isSatellite: true,
      domain,
      debug: env.NEXT_PUBLIC_AUTH_DEBUG,
    },
    mntn: {
      debug: env.NEXT_PUBLIC_AUTH_DEBUG,
    },
    apiBaseUrl: env.NEXT_PUBLIC_AUTH_BASE_URL,
    passBaseUrl: env.NEXT_PUBLIC_PASS_BASE_URL,
    debug: env.NEXT_PUBLIC_AUTH_DEBUG,
    signInUrl: `${env.NEXT_PUBLIC_PASS_BASE_URL}/sign-out`,
  } as const
}

export const clientAuthConfig = coreAuthConfig

export type ClientAuthConfig = ReturnType<typeof clientAuthConfig>

export const serverAuthConfig = async () => {
  const baseConfig = coreAuthConfig()

  const { auth } = await edgeConfig()

  const config = {
    ...baseConfig,
    clerk: {
      ...baseConfig.clerk,
      ...auth.clerk,
      secretKey: env.CLERK_SECRET_KEY,
    },
    mntn: {
      ...auth.mntn,
      proxyUrl: env.MNTN_PROXY_URL,
      clientId: env.MNTN_CLIENT_ID,
      clientSecret: env.MNTN_CLIENT_SECRET,
    },
    splitConfig: {
      serverKey: env.SPLIT_SERVER_KEY,
      readyTimeoutMs: 30_000,
    },
    forceMode: auth.mode,
  } as const

  return config
}
